module.exports = __webpack_public_path__ + "static/media/black-instagram-copy.e817aeb4.svg";